import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export default function isSenderImageEnabled(): boolean {
    return !getIsBitSet(8, getGlobalSettingsAccountMailboxInfo());
}
